import { SpecialAttackSkill, StatusSkill } from "../../core/skill";
import { Effect, RoundEffect } from "../../core/effect";
import { Timing } from "../../core/timing";

import * as type from "../../core/type";
import * as cond from "../../core/cond";
import * as effect from "../../core/effect";
import * as state from "../../core/state";
import { Context } from "../../core/cond";

export const 幻化光芒 = new SpecialAttackSkill(
    "幻化光芒",
    type.光,
    [
        "消除对手的回合类效果，消除成功则免疫下2次异常状态",
        "命中后，40%令对手麻痹，40%令对手害怕，40%令对手睡眠",
        "回合结束时若对手不处于异常状态，则减少对手最大体力的1/3",
    ],
    80,
    [
        new Effect(new effect.消除回合(), Timing.onDamage),
        new Effect(
            new effect.施加异常状态(new state.麻痹()),
            Timing.onDamage,
            cond.百分之x的几率(40),
        ),
        new Effect(
            new effect.施加异常状态(new state.害怕()),
            Timing.onDamage,
            cond.百分之x的几率(40),
        ),
        new Effect(
            new effect.施加异常状态(new state.睡眠()),
            Timing.onDamage,
            cond.百分之x的几率(40),
        ),
    ],
    3,
);

export const 时空裂痕 = new SpecialAttackSkill(
    "时空裂痕",
    type.普通,
    ["对手为自身天敌时造成的伤害提升50%", "击败对手后，此技能的威力降低50%（最低威力降低到125点）"],
    500,
    [new Effect(new effect.增伤(100), Timing.beforeDamage, cond.若对手为自身的天敌)],
    undefined,
    false,
);

export const 光芒附体 = new StatusSkill(
    "光芒附体",
    [
        "全属性+1，先出手时强化效果翻倍",
        "恢复自身最大体力的1/1，并造成等量的固定伤害",
        "3回合内，若自身的能力提升状态被消除，则减少对手最大体力的1/2",
        "下2回合先制+2且直接攻击必定致命一击",
    ],
    [
        new Effect(new effect.强化(), Timing.onSkillHit, cond.若先出手),
        new RoundEffect(
            Timing.onSkillHit,
            2,
            new effect.暴击(),
            Timing.beforeDamage,
            undefined,
            false,
            [],
        ).nextRound(),
    ],
);

export const 奇幻光芒 = new SpecialAttackSkill(
    "奇幻光芒",
    type.光,
    [
        "消除对手的能力提升，消除成功则对手2回合内无法处于能力提升状态",
        "命中后，80%令对手烧伤，80%令对手冻伤，80%令对手中毒",
        "当回合未击败对手，则免疫下1回合受到的攻击",
    ],
    150,
    [
        new Effect(new effect.消除强化(), Timing.onDamage),
        new Effect(
            new effect.施加异常状态(new state.烧伤()),
            Timing.onDamage,
            cond.百分之x的几率(80),
        ),
        new Effect(
            new effect.施加异常状态(new state.冻伤()),
            Timing.onDamage,
            cond.百分之x的几率(80),
        ),
        new Effect(
            new effect.施加异常状态(new state.中毒()),
            Timing.onDamage,
            cond.百分之x的几率(80),
        ),
    ],
);

export const 七彩光芒 = new SpecialAttackSkill(
    "七彩光芒",
    type.光,
    [
        "无视对手免疫伤害效果",
        "威力随机提升，最高威力提升到240点",
        "附加自身最大体力30%的固定伤害并恢复等量体力，自身体力低于1/3时效果翻倍",
        "技能成功释放后，3回合内若主动切换精灵，则该精灵恢复全部体力和活力",
    ],
    160,
    [
        new Effect(
            new effect.固伤(
                (context: Context) => {
                    return Math.floor(context.sbjPet.最大体力 * 0.3);
                },
            ),
            Timing.onDamage,
        ),
    ],
    undefined,
    true,
);

function foo(context: Context): number {
    const damage = Math.floor(context.sbjPet.最大体力 * 0.3);
    if (cond.若自身体力低于x分之一(3)(context)) {
        return damage * 2;
    } else {
        return damage;
    }
}
